import { useEffect } from 'react'

/** La pagina sotto non scorre mentre il dialogo è aperto (dialogo delle landing e modale della home). */
export function useNoPageScroll() {
  useEffect(() => {
    const root = document.documentElement
    const previous = root.style.overflow
    root.style.overflow = 'hidden'
    return () => {
      root.style.overflow = previous
    }
  }, [])
}
